import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/mobile',
      name: '首页',
      component: () => import('@/views/mobile/index')
    },
    {
      path: '/mobile/',
      name: '首页',
      component: () => import('@/views/mobile/index')
    },
    {
      path: '/mobile/goods/detail',
      name: '商品详细',
      component: () => import('@/views/mobile/goods/detail')
    },
    {
      path: '/mobile/goods/buy',
      name: '收银台',
      component: () => import('@/views/mobile/goods/buy')
    },
    {
      path: '/mobile/user/recharge',
      name: '账户充值',
      component: () => import('@/views/mobile/user/recharge')
    },
    {
      path: '/mobile/user/income',
      name: '收支明细',
      component: () => import('@/views/mobile/user/income')
    },
    {
      path: '/mobile/shop',
      name: '店铺资料',
      component: () => import('@/views/mobile/shop/index')
    },
    { path: '*', redirect: '/404', hidden: true },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/',
      name: '首页',
      component: () => import('@/views/pc/index')
    },
    {
      path: '/goods/detail',
      name: '商品详细',
      component: () => import('@/views/pc/goods/detail')
    },
    {
      path: '/goods/buy',
      name: '下单',
      component: () => import('@/views/pc/goods/buy')
    },
    {
      path: '/user/recharge',
      name: '充值',
      component: () => import('@/views/pc/user/recharge')
    },
    {
      path: '/user/income',
      name: '收支明细',
      component: () => import('@/views/pc/user/income')
    },
    {
      path: '/shop',
      name: '店铺资料',
      component: () => import('@/views/pc/shop/index')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js